<style lang="postcss">
	.rating-cover {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: fit-content;
		position: relative;
	}
	.rating-items {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-left: -0.125rem;
		width: fit-content;
	}
	.rating-label {
		cursor: pointer;
		display: flex;
		flex-direction: row;
		padding: 0.25rem;
	}
	.rating-label:first-of-type {
		padding-left: 0;
	}
	.rating-label:not(.active) {
		filter: grayscale(0.5);
		opacity: 0.5;
	}
	.rating-label.disabled,
	.rating-label.active,
	.rating-label.pseudo {
		filter: grayscale(0);
		opacity: 1;
	}
	.icon-cover {
		width: 2.75rem;
		height: 2.75rem;
	}
	.footer-labels {
		line-height: 4px;
		display: flex;
		width: 100%;
		justify-content: space-between;
		font-size: 0.75rem;
		opacity: 0.4;
	}
	@media (hover: hover) {
		.rating-label {
			transition-property: transform, filter;
			transition-duration: 150ms;
			transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		}
		.rating-label:hover {
			filter: grayscale(0);
			opacity: 1;
		}
		.rating-label:hover {
			filter: grayscale(0);
			transform: scale(1.05);
		}
	}
</style>

<script lang="ts">
	import { clickOutside } from "$lib/actions";
	import { tooltip } from "design/actions/tooltip";
	import { createSurveyIcons } from "$lib/data/surveyIcons";
	import { BROWSER } from "esm-env";
	import Smiley from "$lib/Components/Form/Fields/Shared/Smiley.svelte";
	import {
		createEventDispatcher,
		onDestroy,
		onMount,
		getContext
	} from "svelte";

	const dispatch = createEventDispatcher();

	export let field: RatingField;
	export let disabled: boolean = false;
	export let value: string = "";
	const device = getContext<string>("device");

	let wasClicked: boolean = false;
	let inputRef: HTMLDivElement;
	let mobile = ["mobile", "tablet"].includes(device) === true;

	const surveyIcons = createSurveyIcons();
	const starIcon = surveyIcons.find((x) => x.type === "star");
	const thumbIcons = surveyIcons.filter((x) => x.type === "thumb");

	const clickElement = (e: MouseEvent) => {
		if (wasClicked === true) return;
		dispatch("click");
		wasClicked = true;
	};

	onMount(() => {
		if (!BROWSER) return;
		inputRef.addEventListener("click", clickElement);
	});

	onDestroy(() => {
		if (!BROWSER) return;
		inputRef.removeEventListener("click", clickElement);
	});
</script>

<div
	bind:this="{inputRef}"
	style="margin-bottom: {mobile ? '0.5rem' : '0'}"
	class="rating-cover"
	use:clickOutside="{{
		callbackFunction: () => {
			if (wasClicked) {
				dispatch('clickOutside');
				wasClicked = false;
			}
		}
	}}">
	<div class="rating-items">
		{#if field.settings.type === "star" && starIcon}
			{#each [...Array(5).keys()] as icon}
				<label
					class:disabled="{disabled}"
					class:pseudo="{parseInt(value) > icon + 1}"
					class:active="{parseInt(value) === icon + 1}"
					use:tooltip="{{
						disabled: mobile,
						content: field.settings.labels[icon],
						placement: 'top'
					}}"
					class="rating-label">
					<input
						type="radio"
						bind:group="{value}"
						class="hidden-input"
						name="{field.id}"
						value="{(icon + 1).toString()}" />
					<div class="icon-cover">{@html starIcon.html}</div>
				</label>
			{/each}
		{:else if field.settings.type === "thumb" && thumbIcons}
			{#each thumbIcons as icon, index}
				<label
					class:disabled="{disabled}"
					class:active="{parseInt(value) === index}"
					use:tooltip="{{
						disabled: mobile,
						content: field.settings.labels[index],
						placement: 'top'
					}}"
					class="rating-label">
					<input
						type="radio"
						bind:group="{value}"
						class="hidden-input"
						name="{field.id}"
						value="{index.toString()}" />
					<div class="icon-cover">{@html icon.html}</div>
				</label>
			{/each}
		{:else if field.settings.type === "smiley"}
			{#each [...Array(5).keys()] as icon, index}
				<label
					class:disabled="{disabled}"
					use:tooltip="{{
						disabled: mobile,
						content: field.settings.labels[index],
						placement: 'top'
					}}"
					class:active="{parseInt(value) === index + 1}"
					class="rating-label">
					<input
						type="radio"
						bind:group="{value}"
						class="hidden-input"
						name="{field.id}"
						value="{(index + 1).toString()}" />
					<div class="icon-cover">
						<Smiley rating="{index + 1}" />
					</div>
				</label>
			{/each}
		{/if}
	</div>
	{#if mobile}
		<div class="footer-labels">
			<span>{field.settings.labels[0]}</span>
			<span>{field.settings.labels[field.settings.labels.length - 1]}</span>
		</div>
	{/if}
</div>
